export default {
  getUserData: state => state.userEdited,
  getUsers: state => state.users,
  getDrivers: state => state.drivers,
  getParamedics: state => state.paramedics,
  getMedicineDoctors: state => state.medicineDoctors,
}
